export const quoteModels = {
  '00302-ADP': { item: 'polo', sizes: ['120', '130', '140', '150', 'SS', 'S', 'M', 'L', 'LL', '3L', '4L', '5L'] },
  '00342-ASZ': { item: 'hoodie', sizes: ['120', '130', '140', '150', 'SS', 'S', 'M', 'L', 'LL', '3L'] },
  '00338-AMZ': { item: 'hoodie', sizes: ['SS', 'S', 'M', 'L', 'LL', '3L', '4L', '5L'] },
  '5001-01': { item: 'tshirt', sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'] },
  '5900-01': { item: 'tshirt', sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', '5XL', '6XL'] },
  '5011-01': { item: 'tshirt', sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
  '2020-01': { item: 'polo', sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL', '5XL'] },
  '5044-01': { item: 'sweatshirt', sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'] },
  '5214-01': { item: 'hoodie', sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'] },
  '5213-01': { item: 'hoodie', sizes: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'] },
};

export function getQuoteSelection(search) {
  const parameters = new URLSearchParams(search);
  const requested = parameters.get('model');
  const model = Object.hasOwn(quoteModels, requested) ? requested : '';
  const requestedItem = parameters.get('item');
  const item = model ? quoteModels[model].item : ['tshirt', 'polo', 'hoodie', 'sweatshirt', 'other'].includes(requestedItem) ? requestedItem : '';
  return { item, model };
}

export function getInquiryMode(search) {
  return new URLSearchParams(search).get('mode') === 'budget' ? 'budget' : 'quote';
}

export function calculateBudgetGuide(amount, basis, quantity) {
  const positiveInteger = (value, max) => /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0 && Number(value) <= max;
  if (!positiveInteger(amount, 1000000000) || !positiveInteger(quantity, 99999) || !['total', 'unit'].includes(basis)) return null;
  return basis === 'total'
    ? { type: 'unit', value: Number(amount) / Number(quantity) }
    : { type: 'total', value: Number(amount) * Number(quantity) };
}

export function evaluateSizeBreakdown(entries, model) {
  const allowed = Object.hasOwn(quoteModels, model) ? quoteModels[model].sizes : null;
  let total = 0;
  const invalid = [];
  const unsupported = [];
  for (const { size, value } of entries) {
    if (value === '') continue;
    const count = Number(value);
    if (!/^\d+$/.test(String(value)) || !Number.isSafeInteger(count) || count < 0 || count > 99999) {
      invalid.push(size);
    } else if (count > 0 && allowed && !allowed.includes(size)) {
      unsupported.push(size);
    } else {
      total += count;
    }
  }
  return { total, invalid, unsupported, valid: invalid.length === 0 && unsupported.length === 0 && total <= 99999 };
}

const started = new WeakSet();
function initConsultation(root) {
  if (started.has(root)) return;
  const form = root.querySelector('form');
  const item = root.querySelector('[data-pc-contact-item]');
  const model = root.querySelector('[data-pc-contact-model]');
  if (!form || !item || !model) return;
  started.add(root);
  const planned = root.querySelector('[data-pc-planned-count]');
  const inputs = [...root.querySelectorAll('[data-pc-size]')];
  const total = root.querySelector('[data-pc-size-total]');
  const totalField = root.querySelector('[data-pc-size-total-field]');
  const notice = root.querySelector('[data-pc-size-notice]');
  const useTotal = root.querySelector('[data-pc-use-total]');
  const modes = [...root.querySelectorAll('[data-pc-inquiry-mode]')];
  const budgetAmount = root.querySelector('[data-pc-budget-amount]');
  const budgetBasis = root.querySelector('[data-pc-budget-basis]');
  const budgetGuide = root.querySelector('[data-pc-budget-guide]');
  function updateBudgetGuide() {
    if (!budgetAmount || !budgetBasis || !budgetGuide) return;
    const result = calculateBudgetGuide(budgetAmount.value, budgetBasis.selectedOptions[0]?.dataset.basis, planned.value);
    const format = new Intl.NumberFormat('ja-JP', { maximumFractionDigits: 2 });
    budgetGuide.textContent = result
      ? root.dataset[result.type === 'unit' ? 'budgetUnitLabel' : 'budgetTotalLabel'].replace('__AMOUNT__', format.format(result.value))
      : root.dataset.budgetEmptyLabel;
  }
  function updateInquiryMode() {
    const isBudget = modes.find(input => input.checked)?.dataset.pcInquiryMode === 'budget';
    const hint = root.querySelector('[data-pc-mode-hint]');
    const submit = root.querySelector('[data-pc-submit-label]');
    const required = root.querySelector('[data-pc-budget-required]');
    if (budgetAmount) budgetAmount.required = isBudget;
    if (required) required.hidden = !isBudget;
    if (hint) hint.textContent = isBudget ? root.dataset.budgetHint : root.dataset.quoteHint;
    if (submit) submit.textContent = isBudget ? root.dataset.budgetSubmit : root.dataset.quoteSubmit;
  }
  function chooseItem(key) {
    const option = [...item.options].find(option => option.dataset.item === key);
    item.value = option?.value || '';
  }
  function filterModels() {
    const category = item.selectedOptions[0]?.dataset.item;
    for (const option of model.options) {
      const excluded = Boolean(option.value && category && category !== 'other' && option.dataset.item !== category);
      option.disabled = excluded;
      option.hidden = excluded;
    }
    if (model.selectedOptions[0]?.disabled) model.value = '';
  }
  function updateSizes() {
    const selected = Object.hasOwn(quoteModels, model.value) ? quoteModels[model.value] : null;
    const result = evaluateSizeBreakdown(inputs.map(input => ({ size: input.dataset.pcSize, value: input.value })), model.value);
    const overflowInput = result.total > 99999 ? inputs.find(input => Number(input.value) > 0 && (!selected || selected.sizes.includes(input.dataset.pcSize))) : null;
    for (const input of inputs) {
      const allowed = !selected || selected.sizes.includes(input.dataset.pcSize);
      const hasValue = input.value !== '' && Number(input.value) !== 0;
      input.closest('[data-pc-size-field]').hidden = !allowed && !hasValue;
      input.disabled = !allowed && !hasValue;
      const unsupported = result.unsupported.includes(input.dataset.pcSize);
      const invalid = result.invalid.includes(input.dataset.pcSize) || input.validity.badInput || input === overflowInput;
      input.setCustomValidity(unsupported ? root.dataset.unsupportedLabel.replace('__SIZES__', input.dataset.pcSize) : invalid ? root.dataset.invalidLabel : '');
      input.setAttribute('aria-invalid', String(unsupported || invalid));
    }
    const badInput = inputs.some(input => input.validity.badInput);
    const valid = result.valid && !badInput;
    total.textContent = valid ? root.dataset.totalLabel.replace('__COUNT__', result.total.toLocaleString('ja-JP')) : '—';
    totalField.value = valid && result.total > 0 ? String(result.total) : '';
    totalField.disabled = !valid || result.total === 0;
    useTotal.disabled = !valid || result.total === 0;
    let message = '';
    if (result.unsupported.length) message = root.dataset.unsupportedLabel.replace('__SIZES__', result.unsupported.join('・'));
    else if (!valid) message = root.dataset.invalidLabel;
    else if (result.total > 0 && planned.value && Number(planned.value) !== result.total) message = root.dataset.mismatchLabel.replace('__COUNT__', result.total.toLocaleString('ja-JP')).replace('__PLANNED__', planned.value);
    notice.textContent = message;
    notice.hidden = !message;
    return result;
  }
  const selection = getQuoteSelection(window.location.search);
  if (selection.item) chooseItem(selection.item);
  if (selection.model) model.value = selection.model;
  const requestedColor = new URLSearchParams(window.location.search).get('color');
  const color = root.querySelector('#pc-color');
  if (color && requestedColor && requestedColor.length <= 200) color.value = requestedColor;
  filterModels();
  updateSizes();
  const selectedMode = modes.find(input => input.dataset.pcInquiryMode === getInquiryMode(window.location.search));
  if (selectedMode) selectedMode.checked = true;
  updateInquiryMode();
  updateBudgetGuide();
  modes.forEach(input => input.addEventListener('change', updateInquiryMode));
  budgetAmount?.addEventListener('input', updateBudgetGuide);
  budgetBasis?.addEventListener('change', updateBudgetGuide);
  item.addEventListener('change', () => { filterModels(); updateSizes(); });
  model.addEventListener('change', () => {
    if (Object.hasOwn(quoteModels, model.value)) chooseItem(quoteModels[model.value].item);
    filterModels();
    updateSizes();
  });
  inputs.forEach(input => input.addEventListener('input', updateSizes));
  planned.addEventListener('input', () => { updateSizes(); updateBudgetGuide(); });
  useTotal.addEventListener('click', () => {
    const result = updateSizes();
    if (!result.valid || result.total < 1 || useTotal.disabled) return;
    planned.value = String(result.total);
    updateSizes();
    updateBudgetGuide();
  });
  form.addEventListener('invalid', event => {
    const details = event.target.closest('.pc-contact-details');
    if (details) details.open = true;
  }, true);
}

if (typeof document !== 'undefined') {
  const init = () => document.querySelectorAll('[data-pc-consultation]').forEach(initConsultation);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
}
